module.exports = __webpack_public_path__ + "static/heroku-64f31c440d055f45002714a8b4a718b9.png";